import { DataTable, Dialog, Loader } from "@/components";
import useOutstandingDueDialog from "./useOutstandingDueDialog";
import { OutstandingDueDialogProps } from "./types";

const OutstandingDueDialog = ({
  open,
  setOpen,
  selectedRow,
}: OutstandingDueDialogProps) => {
  const { columns, documentList, isDocLoading } = useOutstandingDueDialog({ selectedRow });
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={<div className="text-2xl font-bold text-primary">
          {"Outstanding Dues"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
      contentClassName="lg:!max-w-[700px] lg:!w-[700px]"
    >
      {isDocLoading ? <Loader /> :
        <DataTable
          columns={columns}
          data={documentList || []}
          className="shadow-none border-0"
          tableWrapperClassName="p-0"
        />
      }
    </Dialog>
  )
}

export default OutstandingDueDialog;
